export const ConfirmEmailMessages = {
  labels: {
    resend: {
      id: 'auth.ConfirmEmail.Labels.Resend',
      defaultMessage: 'Resend Confirmation Email',
    },
  },
};
